<template>
    <footer class='fixed-bottom d-none 1d-lg-block'>
      <div class="row">
        <div class="offset-md-3 col-md-12">Этапы проведения</div>
      </div>

      <div class="row">
        <div class="col-md-3">Контакты</div>
        <div class="col-md-9">Задать вопрос онлайн</div>
      </div>

      <div class="row">
        <div class="col-md-12">
          Банеры и футерБанеры и футерБанеры и футерБанеры и футерБанеры и футерБанеры и футерБанеры
          и футерБанеры и футерБанеры и футерБанеры и футерБанеры и футерБанеры и футерБанеры и футерБанеры и футерБанеры
          и футерБанеры и футерБанеры и футерБанеры и футерБанеры и футерБанеры и футерБанеры и футерБанеры и футерБанеры
          и футерБанеры и футерБанеры и футерБанеры и футерБанеры и футерБанеры и футерБанеры и футерБанеры и футерБанеры
          и футерБанеры и футерБанеры и футер
        </div>
      </div>
      </footer>
</template>
<script>
export default {
    
}
</script>

